import { createElement } from 'react';
import getDisplayName from './getDisplayName';
import wrap from './wrap';
var provide = function () {
    var providers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        providers[_i] = arguments[_i];
    }
    return function (component) {
        var Provide = function (props) {
            return wrap.apply(void 0, providers)(createElement(component, props));
        };
        Provide.displayName = "provide(" + getDisplayName(component) + ")";
        return Provide;
    };
};
export default provide;
//# sourceMappingURL=provide.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/tools/dist/react/provide.js
// module id = 76
// module chunks = 1